/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{transform as t}from"../utils/transform.js";import{useCombineMotionValues as r}from"./use-combine-values.js";import{useConstant as n}from"../utils/use-constant.js";function o(r,n,o,e){const u="function"==typeof n?n:t(n,o,e);return Array.isArray(r)?s(r,u):s([r],(([t])=>u(t)))}function s(t,o){const s=n((()=>[]));return r(t,(()=>{s.length=0;const r=t.length;for(let n=0;n<r;n++)s[n]=t[n].get();return o(s)}))}export{o as useTransform};
//# sourceMappingURL=use-transform.js.map
